<template>
  <div ref="target"></div>
</template>

<script>
// eslint-disable-next-line no-undef
const getSwal = () => require('sweetalert2')

export default {
  name: 'OnsitePopupPreview',
  mounted() {
    this.swal = getSwal()
    this.fire()
  },
  data() {
    return {
      unupdatableParams: [
        'input',
        'showConfirmButton',
        'showCancelButton',
        'backdrop',
        'width'
      ],
      defaultParams: {
        showClass: {
          backdrop: 'swal2-noanimation', // disable backdrop animation
          popup: '', // disable popup animation
          icon: '' // disable icon animation
        },
        hideClass: {
          popup: '' // disable popup fade-out animation
        },
        focusCancel: false,
        focusConfirm: false,
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCloseButton: true,
        heightAuto: false,
        position: 'bottom'
      }
    }
  },
  props: {
    config: {
      type: Object
    }
  },
  methods: {
    fire() {
      this.$emit('fire')
      this.config.target = this.$refs.target
      this.config.customClass = {
        container: 'relative-container'
      }
      this.swal.fire({ ...this.config, ...this.defaultParams }).then(
        value => this.fire(),
        reason => this.fire()
      )
    },
    update() {
      this.swal.update({ ...this.config })
    }
  },
  watch: {
    config: {
      handler(newVal, oldVal) {
        let unupdatableParams = this.unupdatableParams.filter(
          param => newVal[param] !== oldVal[param]
        )

        if (unupdatableParams.length) {
          return this.fire()
        }
        return this.update()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
>>> .relative-container {
  position: relative;
  max-width: none !important;
  transform: none !important;
  left: 0 !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
}

>>> p {
  font: inherit;
  margin: 0;
}

>>> h2 {
  width: auto;
  text-transform: none;
}
>>> .swal2-title {
  line-break: anywhere;
}
>>> .swal2-content {
  line-break: anywhere;
}
/deep/ .terms-checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: 10px;
}
/deep/ .terms-checkbox-container a,
/deep/ .terms-checkbox-container a:hover {
  color: #15c;
  text-decoration: underline;
}
/deep/ .contact-field {
  margin-top: 10px;
  width: 250px;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/common/components/onsite/OnsitePopupPreview.vue